module.exports = __webpack_public_path__ + "img/img_7.44ad3f0d.png";